import { render, staticRenderFns } from "./DashboardNav.vue?vue&type=template&id=0d452ca5&scoped=true&"
var script = {}
import style0 from "./DashboardNav.vue?vue&type=style&index=0&id=0d452ca5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d452ca5",
  null
  
)

export default component.exports